mutation RecordYouTubeConsent {
  result: StreamToolsRecordYouTubeConsent {
    accountId
    youtubeConsentAt
  }
}
